import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createVNode as _createVNode, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "toggle-public-note" }
const _hoisted_2 = { class: "flex items-center justify-between mb-1" }
const _hoisted_3 = { class: "text-sm text-text-default" }

import PublicPageListItem from '@/components/widgets/PublicPageListItem';
import ToggleButton from '@/components/elements/ToggleButton';
import { ResourceType } from '@/types/resources';
import useTranslate from '@/utilities/composables/useTranslate';


export default /*@__PURE__*/_defineComponent({
  __name: 'TogglePublicNote',
  props: {
  url: {
    type: String,
    required: true,
  },
},
  emits: ['click'],
  setup(__props, { emit: __emit }) {

const { translate } = useTranslate();

const emit = __emit;



const handleToggleClick = (value) => emit('click', value);

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("span", _hoisted_3, _toDisplayString(_unref(translate)('shareToWeb')), 1),
      _cache[0] || (_cache[0] = _createTextVNode()),
      _createVNode(_unref(ToggleButton), {
        "default-value": !!__props.url,
        onClick: handleToggleClick
      }, null, 8, ["default-value"])
    ]),
    _cache[1] || (_cache[1] = _createTextVNode()),
    _createVNode(_unref(PublicPageListItem), {
      url: __props.url,
      type: _unref(ResourceType).Note,
      "show-link-section": true
    }, null, 8, ["url", "type"])
  ]))
}
}

})